import {
  GlobalStatusType,
  OnboardingStatus,
  StatusColor,
  StatusType,
  SwitchableCustomerType,
  UserType,
} from '../types';

export type LoginAction = {
  type: 'login';
  user: UserType;
  primary_token?: string;
  secondary_token?: string;
};

type RegisterAbortControllerAction = {
  type: 'register_abort_controller';
  abortController: AbortController;
};

type RemoveAbortControllerAction = {
  type: 'remove_abort_controller';
  abortController: AbortController;
};

export type LogoutAction = {
  type: 'logout';
  status: StatusType;
};

export type SetCustomerListAction = {
  type: 'set_customer_list';
  customers: Array<SwitchableCustomerType>;
};

export type SwitchCustomerAction = {
  type: 'switch_customer';
  user: UserType | null;
};

export type GlobalStatusAction = {
  type: 'set_global_status';
  status: GlobalStatusType;
};

export type SetOnboardingStatusAction = {
  type: 'set_onboarding_status';
  status: OnboardingStatus;
};

export type SetUseAuth0FrontendAction = {
  type: 'set_auth0_frontend';
  status: boolean;
};

export type SetLoginEmailAction = {
  type: 'set_login_email';
  email: string;
};

export type SetLoginErrorAction = {
  type: 'set_login_error';
  error: string;
};

export type ClearGlobalStatusSerialAction = {
  type: 'clear_global_status_serial';
  serialNumber: number;
};

export type CloseBrowserAlertAction = {
  type: 'close_browser_alert';
  isBrowserAlertClosed: boolean;
};

export type SessionAction =
  | LoginAction
  | LogoutAction
  | SetCustomerListAction
  | SwitchCustomerAction
  | GlobalStatusAction
  | SetOnboardingStatusAction
  | SetUseAuth0FrontendAction
  | SetLoginEmailAction
  | SetLoginErrorAction
  | ClearGlobalStatusSerialAction
  | CloseBrowserAlertAction
  | RegisterAbortControllerAction
  | RemoveAbortControllerAction;

export const SESSION_ACTIONS = {
  LOGIN: (
    user: UserType,
    primary_token?: string,
    secondary_token?: string,
  ): LoginAction => ({
    type: 'login',
    user,
    primary_token,
    secondary_token,
  }),
  LOGOUT: (message: string, color: StatusColor): LogoutAction => ({
    type: 'logout',
    status: { message, color },
  }),
  SET_CUSTOMER_LIST: (
    customers: Array<SwitchableCustomerType>,
  ): SetCustomerListAction => ({
    type: 'set_customer_list',
    customers,
  }),
  SWITCH_CUSTOMER: (user: UserType | null): SwitchCustomerAction => ({
    type: 'switch_customer',
    user,
  }),
  SET_GLOBAL_STATUS: (status: GlobalStatusType): GlobalStatusAction => ({
    type: 'set_global_status',
    status,
  }),
  SET_ONBOARDING_STATUS: (
    status: OnboardingStatus,
  ): SetOnboardingStatusAction => ({
    type: 'set_onboarding_status',
    status,
  }),
  SET_AUTH0_FRONTEND: (status: boolean): SetUseAuth0FrontendAction => ({
    type: 'set_auth0_frontend',
    status,
  }),
  SET_LOGIN_EMAIL: (email: string): SetLoginEmailAction => ({
    type: 'set_login_email',
    email,
  }),
  SET_LOGIN_ERROR: (error: string): SetLoginErrorAction => ({
    type: 'set_login_error',
    error,
  }),
  CLEAR_GLOBAL_STATUS_WITH_SERIAL: (
    serialNumber: number,
  ): ClearGlobalStatusSerialAction => ({
    type: 'clear_global_status_serial',
    serialNumber,
  }),
  CLOSE_BROWSER_ALERT: (): CloseBrowserAlertAction => ({
    type: 'close_browser_alert',
    isBrowserAlertClosed: true,
  }),
  REGISTER_ABORT_CONTROLLER: (
    abortController: AbortController,
  ): RegisterAbortControllerAction => ({
    type: 'register_abort_controller',
    abortController,
  }),
  REMOVE_ABORT_CONTROLLER: (
    abortController: AbortController,
  ): RemoveAbortControllerAction => ({
    type: 'remove_abort_controller',
    abortController,
  }),
};
